module.exports = __webpack_public_path__ + "img/ESF-EU-Logo.ff705ed3.jpg";